import { UserFormGroup } from '../UserFormGroup';
import { AssociationControls } from './AssociationFormBuilder';
import { BillAddressFormGroup } from '../BillAddressFormGroup';
import { BillAddressOption } from './BillAddressFormBuilder';
import { BaryUserControls, RestrictedBaryUserControls } from './BaryUserFormBuilder';
import { IGenericBaryFormGroup } from '../GenericBaryFormGroup';
import { AddressFormGroup } from '../AddressFormGroup';
import { CompanyControls } from './CompanyFormBuilder';
import { IFormBuilder } from '../IFormBuilder';
import { BaryFormFactoryService } from '../../../services/bary-form-factory.service';
import { AddressOption } from './AddressFormBuilder';
import { UserTypeEnum } from '../../enums/user-type.enum';

export type BaryFormControls = { [key: string]: IGenericBaryFormGroup<any> } & {
  addressForm?: AddressFormGroup;
  billAddressForm?: BillAddressFormGroup;
  userForm?: IGenericBaryFormGroup<BaryUserControls | RestrictedBaryUserControls>;
  companyForm?: IGenericBaryFormGroup<CompanyControls>;
  associationForm?: IGenericBaryFormGroup<AssociationControls>;
};

interface IBaryFormBuilder extends IFormBuilder<BaryFormControls> {
  init(): IBaryFormBuilder;

  build(): IGenericBaryFormGroup<BaryFormControls>;
}

export class BaryFormBuilder implements IBaryFormBuilder {
  private formName = 'baryForm';
  controls: BaryFormControls = {};

  constructor(private bcf: BaryFormFactoryService) {}

  init(): BaryFormBuilder {
    return this;
  }

  addAddressForm(option?: AddressOption): BaryFormBuilder {
    this.controls.addressForm = this.bcf.makeAddressForm(option);
    return this;
  }

  addBillAddressForm(option?: BillAddressOption): BaryFormBuilder {
    this.controls.billAddressForm = this.bcf.makeBillAddressForm(option);
    return this;
  }

  addRestrictedUserForm(baryUserType: UserTypeEnum = UserTypeEnum.COMPANY): BaryFormBuilder {
    this.controls.userForm = this.bcf.makeRestrictedBaryUserForm(baryUserType);
    return this;
  }

  addRegistrationUserForm(baryUserType: UserTypeEnum = UserTypeEnum.COMPANY): BaryFormBuilder {
    this.controls.userForm = this.bcf.makeRegistrationUserForm(baryUserType);
    return this;
  }

  addCompanyForm(): BaryFormBuilder {
    this.controls.companyForm = this.bcf.makeCompanyForm();
    return this;
  }

  addAssociationForm(): BaryFormBuilder {
    this.controls.associationForm = this.bcf.makeAssociationForm();
    return this;
  }

  build(): UserFormGroup {
    return new UserFormGroup(this.formName, this.controls);
  }
}
